import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export function UnverifiedBcrEntriesTable({ data }: { data: auditReports.BcrEntryDto[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<auditReports.BcrEntryDto>($t, {
          accessor: (row) => row.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<auditReports.BcrEntryDto>($t, {
          accessor: (row) => row.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
      ]}
    />
  );
}
